import React from "react";
import { Box, Typography } from "@mui/material";

// Logo institucional ABG · EBG. El PNG es blanco sobre transparente, asi que
// se apoya sobre los fondos oscuros del tema sin necesidad de recortes.
// `subtitle` identifica el portal (Control Academico, Administrativo, ...).
const BrandLogo = ({ subtitle, href = "/", dense = false }) => (
  <Box
    component={href ? "a" : "div"}
    href={href || undefined}
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      textDecoration: "none",
      color: "inherit",
      minWidth: 0,
    }}
  >
    <Box
      component="img"
      src="/logo-abg-ebg-blanco.png"
      alt="ABG · Escuela Bancaria de Guatemala"
      sx={{
        height: dense ? 30 : 40,
        width: "auto",
        maxWidth: dense ? 130 : 168,
        objectFit: "contain",
        display: "block",
        flexShrink: 0,
      }}
    />
    {subtitle && !dense && (
      <Box sx={{ minWidth: 0 }}>
        <Typography
          noWrap
          sx={{ fontSize: 11, color: "text.secondary", lineHeight: 1.3 }}
        >
          {subtitle}
        </Typography>
      </Box>
    )}
  </Box>
);

export default BrandLogo;
